export const createThumbnailFromVideoAtOffset = async (videoUrl: string, offsetMiliseconds: number): Promise<File | undefined> => {
  return new Promise((resolve, reject) => {
    try {
      const video = document.createElement('video');

      video.src = videoUrl;
      video.crossOrigin = 'anonymous';
      video.preload = 'auto';

      video.addEventListener('loadeddata', () => {
        video.currentTime = offsetMiliseconds / 1000;
      });

      video.addEventListener('seeked', async () => {
        const canvas = document.createElement('canvas');

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext('2d');

        if (ctx) {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(
            (blob) => {
              if (blob) {
                const file = new File([blob], 'thumbnail.jpeg', { type: 'image/jpeg' });

                resolve(file);
              } else {
                reject('Could not create blob from canvas');
              }
            },
            'image/jpeg',
            0.8
          );
        } else {
          reject('Could not get canvas context');
        }
      });

      video.addEventListener('error', () => {
        reject('Error loading video');
      });
    } catch (err) {
      reject(err);
    }
  });
};
